import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../login';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
var PostJobsComponent = /** @class */ (function () {
    function PostJobsComponent(dashboardService, errorHandlerService, router, userService) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.userService = userService;
        this.postJob = {};
        this.countries = [];
        this.states = [];
        this.cities = [];
        this.results = [];
        this.usertyperesults = [];
        this.cityresults = [];
        this.temp = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
    }
    PostJobsComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    PostJobsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var s1 = this.userService.country().subscribe(function (data) {
            _this.countries = data;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
    };
    PostJobsComponent.prototype.onChange = function (countryid) {
        var _this = this;
        var s2 = this.userService.state(countryid).subscribe(function (data) {
            console.log(data);
            _this.states = data;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    PostJobsComponent.prototype.searchstate = function (event) {
        this.results = this.filterstate(event.query, this.states);
    };
    PostJobsComponent.prototype.filterstate = function (query, states) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        var filtered = [];
        var state_data = [];
        for (var i = 0; i < states.length; i++) {
            var state = states[i];
            if (state.stateFullName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                state_data.name = state.stateFullName;
                state_data.stateId = state.stateId;
                filtered.push(state_data);
                state_data = [];
            }
        }
        return filtered;
    };
    PostJobsComponent.prototype.handleDropdownClick = function (state) {
        var _this = this;
        console.log(state.stateId);
        this.postJob.stateId = state.stateId;
        var s3 = this.userService.city(state.stateId).subscribe(function (data) {
            console.log(data);
            _this.cities = data;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s3);
    };
    PostJobsComponent.prototype.handleDropdownClick2 = function (city) {
        this.postJob.cityId = city.cityId;
    };
    PostJobsComponent.prototype.searchcity = function (event) {
        this.cityresults = this.filtercity(event.query, this.cities);
    };
    PostJobsComponent.prototype.filtercity = function (query, cities) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        var filtered = [];
        var city_data = [];
        for (var i = 0; i < cities.length; i++) {
            var city = cities[i];
            if (city.cityFullName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                city_data.name = city.cityFullName;
                city_data.cityId = city.cityId;
                filtered.push(city_data);
                city_data = [];
            }
        }
        return filtered;
    };
    PostJobsComponent.prototype.filterstateid = function (selectedState) {
        var stateid;
        var states = this.states;
        for (var i = 0; i < states.length; i++) {
            var state = states[i];
            if (state.stateFullName == selectedState) {
                stateid = state.stateId;
            }
        }
        return stateid;
    };
    PostJobsComponent.prototype.postNewJob = function () {
        var _this = this;
        console.log(this.postJob);
        if (this.temp.state != null && this.temp.city != null) {
            var s4 = this.dashboardService.postNewJob(this.postJob).subscribe(function (data) {
                console.log(data);
                _this.router.navigate(['dashboard/viewjob'], { queryParams: { jobId: data.jobsId } });
            }, function (error) {
                _this.handleError(error);
            });
            this.subscriptions.push(s4);
        }
    };
    PostJobsComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    PostJobsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return PostJobsComponent;
}());
export { PostJobsComponent };
//# sourceMappingURL=postjobs.component.js.map